module.exports = __webpack_public_path__ + "img/12.ed42743a.jpg";